import { useState } from 'react'
import SidePage from '@/shared/SidePage'
import { IMDMUnit } from '@/pages/MDM/mdm.types.ts'
import ViewUnitSidePageContent from '@/pages/MDM/components/Units/UnitSidePage/ViewUnitSidePageContent'
import EditUnitSidePageContent from '@/pages/MDM/components/Units/UnitSidePage/EditUnitSidePageContent'

interface IProps {
  open: boolean
  onClose: () => void
  onCloseAnimationEnd?: () => void
  unit: IMDMUnit
}

const UnitSidePage = (props: IProps) => {
  const [pageMode, setPageMode] = useState<'view' | 'edit'>('view')

  const renderContent = () => {
    switch (pageMode) {
      case 'view':
        return <ViewUnitSidePageContent unit={props.unit} onClose={props.onClose} onEdit={() => setPageMode('edit')} />
      case 'edit':
        return <EditUnitSidePageContent onClose={() => setPageMode('view')} unit={props.unit} />
    }
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} onCloseAnimationEnd={props.onCloseAnimationEnd}>
      {renderContent()}
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.unit) return null

  return <UnitSidePage {...props} />
}
